import * as React from 'react'
import {
    Grid,
    FormGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Box,
} from '@mui/material'
import UserSelect from '@/Components/Elements/Select/UserSelect'
import SelectRC from 'rc-select/lib/index.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons'

export const StepOne = ({
    kedo,
    state,
    setPartialState,
    transformContactsForPayload,
}) => {
    const handleChangeRecipients = (checked, person) => {
        const updated = checked
            ? [...state.recipientDossierPersons, person]
            : state.recipientDossierPersons.filter((r) => r.id !== person.id)
        setPartialState({ recipientDossierPersons: updated })
        transformContactsForPayload(
            state.recipientUsers,
            updated,
            state.recipientCustomEmails
        )
    }

    return (
        <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
                {state.secureShareSettings && (
                    <Box sx={{ mb: 3 }}>
                        <Box
                            component="h3"
                            sx={{ fontSize: '1rem', fontWeight: 600, mb: 2 }}
                        >
                            {kedo.t('Add recipients from dossier', {
                                ns: 'secureshare',
                            })}
                        </Box>
                        <FormGroup>
                            {state.dossierPersons.map((p) => (
                                <FormControlLabel
                                    key={p.id}
                                    control={
                                        <Checkbox
                                            checked={state.recipientDossierPersons.includes(
                                                p
                                            )}
                                            onChange={(e) =>
                                                handleChangeRecipients(
                                                    e.target.checked,
                                                    p
                                                )
                                            }
                                        />
                                    }
                                    label={[p.name, p.email, p.mobile]
                                        .filter(Boolean)
                                        .join(' ')}
                                />
                            ))}
                        </FormGroup>
                    </Box>
                )}
                {state.secureShareSettings?.allow_add_users && (
                    <Box sx={{ mb: 3 }}>
                        <Box
                            component="h3"
                            sx={{ fontSize: '1rem', fontWeight: 600, mb: 2 }}
                        >
                            {kedo.t('Add users', { ns: 'secureshare' })}
                        </Box>
                        <UserSelect
                            currentUsers={state.recipientUsers}
                            kedo={kedo}
                            onChangeUsers={(values) => {
                                setPartialState({ recipientUsers: values })
                                transformContactsForPayload(
                                    values,
                                    state.recipientDossierPersons,
                                    state.recipientCustomEmails
                                )
                            }}
                        />
                    </Box>
                )}
            </Grid>
            {state.secureShareSettings?.allow_email_specific && (
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box sx={{ mb: 3 }}>
                        <Box
                            component="h3"
                            sx={{ fontSize: '1rem', fontWeight: 600, mb: 2 }}
                        >
                            {kedo.t('Add custom mail addresses', {
                                ns: 'secureshare',
                            })}
                        </Box>
                        <SelectRC
                            mode="tags"
                            allowClear
                            open={false}
                            className="w-100 custom-select-react"
                            value={state.recipientCustomEmails.map(
                                (i) => i.value
                            )}
                            onSearch={(value) =>
                                setPartialState({
                                    recipientCustomEmailsInput: value,
                                })
                            }
                            onChange={(newEmails: string[]) => {
                                const formatted = newEmails.map((value) => ({
                                    label: value,
                                    value,
                                }))
                                setPartialState({
                                    recipientCustomEmails: formatted,
                                })
                                transformContactsForPayload(
                                    state.recipientUsers,
                                    state.recipientDossierPersons,
                                    formatted
                                )
                            }}
                            suffixIcon={
                                <FontAwesomeIcon icon={faChevronDown} />
                            }
                            placeholder={`${kedo.t('Search')}...`}
                        />
                    </Box>
                </Grid>
            )}
        </Grid>
    )
}
